import { useQuery } from "@tanstack/react-query";
import { BedDouble, BookOpenCheck, Search, UserRound, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

const icons = { apartment: BedDouble, guest: UserRound, booking: BookOpenCheck };

export function GlobalSearch() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const { data = [], isFetching } = useQuery({
    queryKey: ["search", query],
    queryFn: () => api.search(query),
    enabled: query.trim().length >= 2,
    staleTime: 10_000,
  });

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        setOpen(true);
        window.setTimeout(() => inputRef.current?.focus(), 0);
      }
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const select = (path: string) => {
    navigate(path);
    setOpen(false);
    setQuery("");
  };

  if (!open) return <button className="search-box" onClick={() => { setOpen(true); window.setTimeout(() => inputRef.current?.focus(), 0); }}><Search size={15} /><span>Поиск гостя, брони…</span><kbd>⌘K</kbd></button>;

  return <div className="global-search">
    <div className="global-search__field"><Search size={15} /><input ref={inputRef} name="globalSearch" autoComplete="off" aria-label="Глобальный поиск" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Имя, телефон, номер…" /><button onClick={() => { setOpen(false); setQuery(""); }} aria-label="Закрыть поиск"><X size={15} /></button></div>
    <div className="global-search__results" aria-live="polite" aria-busy={isFetching}>
      {query.length < 2 && <p>Введите минимум два символа</p>}
      {isFetching && <p>Ищем…</p>}
      {!isFetching && query.length >= 2 && data.length === 0 && <p>Ничего не найдено</p>}
      {data.map((result) => { const Icon = icons[result.entity]; return <button key={`${result.entity}-${result.id}`} onClick={() => select(result.path)}><span><Icon size={16} /></span><div><strong>{result.title}</strong><small>{result.subtitle}</small></div></button>; })}
    </div>
  </div>;
}
